"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _antd = require("antd");

var _track = _interopRequireDefault(require("../track"));

require("antd/dist/antd.css");

require("./TableComponent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var TableComponent = function TableComponent(_ref) {
  var showTrack = _ref.showTrack,
      setShowTrack = _ref.setShowTrack,
      trackCloseIcon = _ref.trackCloseIcon,
      rows = _ref.rows,
      columns = _ref.columns,
      total = _ref.total,
      _ref$defaultPageSize = _ref.defaultPageSize,
      defaultPageSize = _ref$defaultPageSize === void 0 ? 10 : _ref$defaultPageSize,
      paginationDisabled = _ref.paginationDisabled,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? ["bottomCenter"] : _ref$position,
      _ref$pageSizeOptions = _ref.pageSizeOptions,
      pageSizeOptions = _ref$pageSizeOptions === void 0 ? [10, 20, 50, 100] : _ref$pageSizeOptions,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "small" : _ref$size,
      _ref$showSizeChanger = _ref.showSizeChanger,
      showSizeChanger = _ref$showSizeChanger === void 0 ? true : _ref$showSizeChanger,
      _ref$onShowSizeChange = _ref.onShowSizeChange,
      onShowSizeChange = _ref$onShowSizeChange === void 0 ? function () {} : _ref$onShowSizeChange,
      _ref$showQuickJumper = _ref.showQuickJumper,
      showQuickJumper = _ref$showQuickJumper === void 0 ? true : _ref$showQuickJumper,
      id = _ref.id,
      handlePageClick = _ref.handlePageClick,
      current = _ref.current,
      loading = _ref.loading,
      _ref$showSorterToolti = _ref.showSorterTooltip,
      showSorterTooltip = _ref$showSorterToolti === void 0 ? false : _ref$showSorterToolti,
      _ref$defaultCurrent = _ref.defaultCurrent,
      defaultCurrent = _ref$defaultCurrent === void 0 ? 1 : _ref$defaultCurrent,
      _ref$scrollY = _ref.scrollY,
      scrollY = _ref$scrollY === void 0 ? "20rem" : _ref$scrollY,
      _ref$selectionType = _ref.selectionType,
      selectionType = _ref$selectionType === void 0 ? "checkbox" : _ref$selectionType,
      rowSelectionEnabled = _ref.rowSelectionEnabled,
      onChangeCheckbox = _ref.onChangeCheckbox,
      filterChange = _ref.filterChange,
      setSelectedRowKeys = _ref.setSelectedRowKeys,
      selectedRowKeys = _ref.selectedRowKeys,
      trackList = _ref.trackList,
      emptyText = _ref.emptyText,
      className = _ref.className,
      _ref$preserveSelected = _ref.preserveSelectedRowKeys,
      preserveSelectedRowKeys = _ref$preserveSelected === void 0 ? false : _ref$preserveSelected;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      selectedRows = _useState2[0],
      setSelectedRows = _useState2[1];

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var rowSelection = {
    onChange: function onChange(checkedRowKeys, selectedRowsData) {
      onChangeCheckbox === null || onChangeCheckbox === void 0 ? void 0 : onChangeCheckbox(checkedRowKeys, selectedRowsData);

      if (selectedRowKeys && selectedRowKeys.length >= 0) {
        setSelectedRowKeys(checkedRowKeys);
      } else {
        setSelectedRows(checkedRowKeys);
      }
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "table-main ".concat(className)
  }, showTrack && /*#__PURE__*/_react["default"].createElement(_track["default"], {
    setShowTrack: setShowTrack,
    trackCloseIcon: trackCloseIcon,
    trackList: trackList
  }), /*#__PURE__*/_react["default"].createElement(_antd.Table, {
    columns: columns,
    rowSelection: rowSelectionEnabled && _objectSpread(_objectSpread({
      type: selectionType
    }, rowSelection), {}, {
      selectedRowKeys: (selectedRowKeys === null || selectedRowKeys === void 0 ? void 0 : selectedRowKeys.length) >= 0 ? selectedRowKeys : selectedRows,
      preserveSelectedRowKeys: preserveSelectedRowKeys
    }),
    pagination: !paginationDisabled && {
      total: total,
      defaultPageSize: defaultPageSize,
      position: position,
      pageSizeOptions: pageSizeOptions,
      showSizeChanger: showSizeChanger,
      onShowSizeChange: onShowSizeChange,
      size: size,
      // showQuickJumper: showQuickJumper,
      current: current,
      defaultCurrent: defaultCurrent,
      onChange: function onChange(pageNumber, pageSize) {
        return handlePageClick(pageNumber, pageSize);
      }
    },
    dataSource: rows,
    scroll: {
      y: scrollY
    },
    loading: loading || false,
    showSorterTooltip: showSorterTooltip,
    rowKey: id || "key",
    onChange: filterChange,
    className: "main-table-class iiht-ant-table",
    locale: {
      emptyText: /*#__PURE__*/_react["default"].createElement(_antd.Empty, {
        className: "display-flex align-center flex-direction-column justify-center iiht-ant-empty",
        image: _antd.Empty.PRESENTED_IMAGE_SIMPLE,
        description: emptyText || t("common.noData")
      })
    }
  }));
};

var _default = TableComponent;
exports["default"] = _default;